import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";

const PhManagePhotoshoots = (props) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const getMarshaCode = (hotelAttrs) => {
    if (!hotelAttrs) return "";

    const parts = hotelAttrs.split("#");
    return parts.length >= 3 ? parts[1] : "";
  };
  const getAttrArr = (hotelAttrs) => {
    if (!hotelAttrs) return "";

    const parts = hotelAttrs.split("#");
    return parts;
  };
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0) return "Pending";
    if (code >= 1 && code <= 6) return "In-Process";
    if (code === 7 || code === 8) return "Completed";

    return "Unknown";
  };

  const renderBell = (st) => {
    const redStatus = [1, 2, 3, 5, 7, 9, 11];
    return (
      <div>
        <i className={`fas fa-bell text-${redStatus.includes(Number(st)) ? "red" : "green"}-500`}></i> {status[st + 1]}
      </div>
    );
  };

  const [submitted, setSubmitted] = useState(false);

  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    Pending: "status-pill inline-block bg-pink-50 text-pink-700",
    Completed: "status-pill inline-block bg-gray-200 text-gray-700",
  };

  /* Hotel types */
  const hotel_types = {
    new: "New Property",
    converted: "Converted Property",
    established: "Established Property",
  };

  const [photoshoots, setPhotoshoots] = useState([]);
  const [status, setStatus] = useState([]);

  /* Getting ps status & Photoshoot Listing */
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
      .then((res) => {
        console.log(res);
        if (res.data.success) {
          setStatus(res.data.statuses);
        }
      })
      .then((res) => {
        axios
          .get(Utils.apiUrl(`photoshoot/listing`), Utils.apiHeaders())
          .then((res) => {
            console.log(res);
            if (res.data.success) {
              setPhotoshoots(res.data.data);
            }
          })
          .catch((err) => {
            //callback(false, err.message);
          });
      });
  }, []);

  return (
    <>
      <div className="container mx-auto p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Manage Photoshoot</h1>
        <p className="text-gray-600 mb-6">
          Photoshoot tiles show status visually with background color: Pink = Pending, Yellow = In-Progress, Grey = Completed/Archived.
        </p>

        {/* If photoshoots have no data */}
        {photoshoots.length == 0 && <div className="text-center bg-gray-100 p-3 text-gray-600 rounded">No Record Found!</div>}

        {/* If photoshoots have data */}
        {photoshoots.length > 0 && (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {photoshoots.map((record) => (
                <article className="project-tile bg-white">
                  <div className="p-4 bg-white">
                    <div className="flex items-start justify-between">
                      <div>
                        <h2 className="text-lg font-semibold text-gray-800">{`${getAttrArr(record.hotel_attrs)[0]} - ${getAttrArr(record.hotel_attrs)[1]}`}</h2>
                        <p className="text-sm text-gray-500 mt-1">
                          Type: <span className="font-medium text-gray-700">{hotel_types[record.hotel_type]}</span>
                        </p>
                        <p className="text-sm text-gray-500">
                          Shoot Date:{" "}
                          <span className="font-medium text-gray-700">
                            {formatDate(record.date_from)} - {formatDate(record.date_to)}
                          </span>
                        </p>
                        <p className="text-sm text-gray-500">
                          Photographer: <span className="font-medium text-gray-700">{record.photographer_name}</span>
                        </p>
                        <p className="text-sm text-gray-500">
                          Status: <span className="font-medium text-gray-700">{status[record.status]}</span>
                          {renderBell(record.status)}
                        </p>
                      </div>
                      {/*<div className="ml-3 text-right">
                        <div className={statusClasses[getStatusLabel(record.status)]}>
                          <i className="fa-solid fa-circle"></i>
                        </div>
                      </div>*/}
                    </div>

                    <div className="mt-4 flex space-x-3 text-xs">
                      <a
                        href={`photographer-photoshoot-details/${record.id}`}
                        className="btn inline-flex items-center justify-center px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700"
                      >
                        <i className="fas fa-eye mr-2"></i> View Details
                      </a>
                      <a
                        href="#"
                        className="cta-btn inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-gray-800 rounded hover:bg-gray-100 ctaBrandTeam"
                      >
                        <i className="fas fa-comments mr-2"></i> Contact Brand Team
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PhManagePhotoshoots;
